import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, from, Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { tap, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MainService {
  private url: string = environment.url;

  constructor(private http: HttpClient) { }
  
  
  getHeaders() {
    return {
      headers: new HttpHeaders({
        'content-type': 'application/json',
      }),
      withCredentials: false,
    };
  }

  getPrivateHeaders() {
    return {
      headers: new HttpHeaders({
        'content-type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      }),
      withCredentials: false,
    };
  }
  
  
   // LOGIN method
  login(data: any): Observable<any> {
    return this.http.post(this.url + 'auth/login', data, this.getHeaders()).pipe(
      tap((response: any) => {
        if (response.token) {
          localStorage.setItem('token', response.token);
        }
      }),
      catchError(this.handleError('login'))
    );
  }
  
   // REGISTER method
  register(data: any): Observable<any> {
    return this.http.post(this.url + 'auth/register', data, this.getHeaders()).pipe(
      tap((response: any) => {
        console.log('Registration response:', response);
      }),
      catchError(this.handleError('register'))
    );
  }


    // LOGOUT method
  logout(): void {
    localStorage.removeItem('token');
  }

  // Check if user is logged in
  isLoggedIn(): boolean {
    return !!localStorage.getItem('token');
  }

  getCurrentUser(): any {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  }

  setCurrentUser(user: any) {
    localStorage.setItem('user', JSON.stringify(user));
  }
  
  private handleError<T>(result?: T) {
    return (error: any): Observable<T> => {
      if (error.status == 401) {
        console.log('NU MAI AI ACCES!');
      }
      return of(result as T);
    };
  }
  
  
}
